import { Component, Input, OnInit } from '@angular/core';
import { NewsItem } from '../../models/NewsItem';
import { User } from '../../models/User';
import { HttpService } from '../../services/HttpService';
import { HttpResponse } from '@angular/common/http';
import { GlobalService } from '../../services/global';

@Component({
  selector: 'app-news-item',
  templateUrl: './news-item.component.html',
  styleUrls: ['./news-item.component.css']
})
export class NewsItemComponent implements OnInit {
  @Input() NewsItem: NewsItem;
  @Input() CurUser: User;
  constructor(private http:HttpService, private global:GlobalService) { }

  ngOnInit(): void {
  }

  ViewMoreInfo() {
    if (this.NewsItem.Type == 'directlink' && this.NewsItem.Link && this.NewsItem.Link.length > 0) {
      window.open(this.NewsItem.Link, '_blank');
    } else if (this.NewsItem.Type == 'infocenterfile') {
      this.DownloadFile()
    }
  }


  DownloadFile() {
    this.global.getCurrentDist().then(dist => {
      this.http.PostUserActivity(this.CurUser.UserId.toString(), "Info Center", "Download File", this.NewsItem.InfoCenterFile.FileName, this.CurUser.IsTolomaticUser ? dist.CompanyId : this.CurUser.DistributorId);
    });
    
    if (this.NewsItem.Type == 'infocenterfile') {
      this.http.DownloadInfoCenterFile(this.CurUser.UserId.toString(), this.NewsItem.InfoCenterFileID).subscribe(({ body, headers }: HttpResponse<any>) => {
        debugger;
        var contentType = headers.get('content-type');
        const blob = new Blob([body], { type: contentType });
        var fileURL = URL.createObjectURL(blob);

        var a = document.createElement("a");
        a.href = fileURL;
        a.download = this.NewsItem.InfoCenterFile.FileName;
        a.click();
      });
    }
    else {
      var a = document.createElement("a");
      a.href = this.NewsItem.InfoCenterFile.FullPath;
      a.download = this.NewsItem.InfoCenterFile.FileName;
      a.target = "_blank";
      a.click();
    }
  }

}
